"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["Ordered"] = 0] = "Ordered";
    OrderStatus[OrderStatus["Shipped"] = 1] = "Shipped";
    OrderStatus[OrderStatus["Delivered"] = 2] = "Delivered";
    OrderStatus[OrderStatus["At Lab"] = 3] = "At Lab";
    OrderStatus[OrderStatus["En Route To Lab"] = 4] = "En Route To Lab";
    OrderStatus[OrderStatus["Return To Sender"] = 5] = "Return To Sender";
    OrderStatus[OrderStatus["Failure"] = 6] = "Failure";
    OrderStatus[OrderStatus["Unknown"] = 7] = "Unknown";
    OrderStatus[OrderStatus["Results Ready"] = 8] = "Results Ready";
    OrderStatus[OrderStatus["Completed"] = 9] = "Completed";
    OrderStatus[OrderStatus["Invalidated"] = 10] = "Invalidated";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
//# sourceMappingURL=OrderStatus.js.map